import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'liv-spin-loader',
  imports: [CommonModule],
  templateUrl: './liv-spin-loader.component.html',
  styleUrls: ['./liv-spin-loader.component.scss']
})
export class LivSpinLoaderComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() variant: 'primary' | 'secondary' | 'tertiary' | 'default' =
    'default';

  @Input() message?: string;
}
